import { Select,Form} from 'antd'
import React, { useEffect, useState } from 'react'
import { useBnsXiangMuListQuery } from '../../store/BnsKeJiApi';
function ProjectSelect(props) {    
    const {data,isSuccess} = useBnsXiangMuListQuery({bxm_e_id:'218'},{refetchOnMountOrArgChange:1})    
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                console.log(data);                
                const newArr = data.Result.map(item => {
                    const {bxm_id:key,bxm_name,} = item;
                    return item = {value:key,label:bxm_name,}
                })                
               
                setList(newArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   
    return (
        <>
            <Form.Item 
                label={props.label} 
                wrapperCol={props.wrapperCol} 
                required={props.required}
                name={props.name}
                style={props.FormStyle}
            >
                <Select 
                    options={list} 
                    onChange={(_,f) => {
                        props.onChange(f.value,f.label,f.ed_id,f.ed_name)
                    }}
                    defaultValue={props.defaultId}
                    placeholder={props.defaultId}
                    style={props.style}
                />
            </Form.Item>
        </>
    )
}

export default ProjectSelect